import { useState, useRef, useEffect } from 'react'
import { useLoadProgress } from './useLoadProgress'

/**
 * 暫存功能 hook
 * 有 userId（網址帶入）時自動啟用暫存讀取。
 *
 * 使用方式（在 Agree.js 裡）：
 *
 *   // useConvertSurvey 之前：
 *   const userIdRef = useRef(null)
 *   useEffect(() => { if (userId) userIdRef.current = userId }, [userId])
 *
 *   // surveyModel 之後：
 *   useProgressSaving({ userIdRef, surveyModel, convertedSurvey: myAgreeJson, ... })
 */
export const useProgressSaving = ({
  userIdRef,
  surveyModel,
  convertedSurvey,
  requiresLogin,
  setIsLoading,
  pid,
  ac,
  tk,
  choiceIndexMapRef,
  choicesOrderRef,
  bringOptionsMapRef,
  sfdSamplerId,
}) => {
  const [isReady, setIsReady] = useState(false)
  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  useEffect(() => {
    if (surveyModel) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [surveyModel])

  useLoadProgress({
    surveyModel,
    convertedSurvey,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
    sfdSamplerId,
  })
}
